export function isSchedulerRoute(path) {
  return path.startsWith('/posts')
    || path.startsWith('/recurring')
    || path.startsWith('/social/accounts')
    || path === '/analytics'
}

export function isDesignStudioRoute(path) {
  return path === '/ai/studio' || path.startsWith('/ai/studio/')
}

export function isAIRoute(path) {
  return path === '/ai/assistant' || path.startsWith('/ai/assistant/')
}
